import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

export const getProgramEvents = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.programEvents || [];
  }
);
